import styled, { css } from 'styled-components';

import { largeMediaQuery } from '../../../common/utilities/sizeHelpers';

const LifeIntroTextStyle = css`
    font-size: 16px;
    color: #ffffff;
    white-space: normal;
    width: 100%;
    margin-top: 0;
    @media ${largeMediaQuery} {
        width: calc(100% - 316px);
    }
`;

export const LifeIntroText = styled.div`
    ${LifeIntroTextStyle}
`;

export const LifeHeaderText = styled.h1`
    ${LifeIntroTextStyle}
`;
